<template>
  <div class="join-learning-popup-box">
    <div class="join-learning-popup-box-dialog">
      <icon
        class="join-learning-popup-box-dialog-close"
        type="close-grey"
        @click="close"
      ></icon>
      <div class="join-learning-popup-box-dialog-text">
        您已学完一节，把课程「加入我的学习」记录学习进度和提醒你学习
      </div>
      <button class="join-learning-popup-box-dialog-btn" @click="success">
        好的
      </button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    close() {
      this.$emit('close');
    },
    success() {
      this.$emit('success');
    },
  }
};
</script>

<style lang="scss" scoped>
.join-learning-popup-box {
  background: rgba(0, 0, 0, 0.7);
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  &-dialog {
    left: 50%;
    top: 50%;
    position: absolute;
    width: 332px;
    margin-left: -166px;
    height: 170px;
    margin-top: -85px;
    border-radius: 12px;
    border: 1px solid rgba(17, 19, 23, 0.2);
    background-color: #ffffff;
    &-text {
      margin-top: 38px;
      margin-left: 40px;
      width: 252px;
      line-height: 22px;
      color: #111317;
    }
    &-btn {
      width: 122px;
      height: 34px;
      background: #417ff9;
      border-radius: 18px;
      border: none;
      margin-top: 24px;
      margin-left: 105px;
      cursor: pointer;
      color: #ffffff;
    }
    &-close {
      position: absolute;
      top: 14px;
      right: 14px;
      cursor: pointer;
    }
  }
}
</style>
